import {Component, EventEmitter, Input, Output} from '@angular/core';

import {OngletComponent} from './onglet.component';
import {DonneesOnglet} from './DonneesOnglet';

//Composant barre d’onglets
@Component (
{
  selector: 'val-barre-onglets',
  imports: 
  [
    OngletComponent
  ],
  templateUrl: './barre-onglets.component.html',
  styleUrl: './barre-onglets.component.scss'
})
export class BarreOngletsComponent 
{
  //Création
  constructor () 
  {
    this.onglets = [];
    this.ongletSelectionneChange = new EventEmitter<DonneesOnglet>;
    this.rafraichissementOngletDemande = new EventEmitter<DonneesOnglet>;
    this.ongletSelectionne = null;
  }

  //Onglets
  @Input ()
  public onglets: DonneesOnglet[];

  //Evénement changement d’onglet sélectionné
  @Output ()
  public ongletSelectionneChange: EventEmitter<DonneesOnglet>;

  //Evénement demande de rafraichissement de l’onglet
  @Output ()
  public rafraichissementOngletDemande: EventEmitter<DonneesOnglet>;

  //Onglet sélectionné
  private ongletSelectionne: DonneesOnglet | null;

  //Sélectionne un onglet
  //  Paramètres
  //    onglet : Données de l’onglet
  public SelectionnerOnglet (onglet: DonneesOnglet) : void 
  {
    if (onglet !== this.ongletSelectionne)
    {
      for (const ongletItem of this.onglets)
        ongletItem.selectionne = false;

      onglet.selectionne = true;
      this.ongletSelectionne = onglet;

      this.ongletSelectionneChange.emit (onglet);
    }
  }

  //Rafraichissement de l’onglet
  //  Paramètres
  //    onglet : Données de l’onglet
  public RafraichirOnglet (onglet: DonneesOnglet) : void 
  {
    if (onglet === this.ongletSelectionne)
      this.rafraichissementOngletDemande.emit (onglet);
  }

  //Retourne l’identifiant de l’onglet sélectionné
  public GetIdentifiantOngletSelectionne() : string | null
  {
    return this.ongletSelectionne ? this.ongletSelectionne.identifiant : null;
  }
}
